import { StandardOptionsPage } from "../HousingWishes"

const StandardOptionsWrapper = () => {
  return (
    <>
      <StandardOptionsPage />
    </>    
  )
}

export default StandardOptionsWrapper
